<button mat-icon-button color="primary" (click)="ouvrirDestinataires()" [disabled]="!nom" [matTooltip]="'Contacter vos interlocuteurs ' + (nom | lowercase)"
  *ngIf="nom">
  <mat-icon>people</mat-icon>
</button>
<mat-spinner *ngIf="!nom" diameter="20"></mat-spinner>